import { useForm } from "@mantine/form"
import React, { useState } from "react"
import { CV_LIST_INITIAL_PRESET, DateRange, resolveDateParams } from "../utils/datePreset"
import { Box, Button, Checkbox, Group, Text } from "@mantine/core"
import { DatePresetFilter } from "./DatePresetFilter"

export interface FormData {
  date: string
  duplicate: boolean
  is_test: boolean
  startDate: string | null
  endDate: string | null
}

interface Props {
  onSubmit: (values: FormData) => Promise<void> | void
}

// CV一覧の検索条件入力フォーム（期間/重複除外/テストCV/カスタム日付）
export const CVListSearchForm = ({ onSubmit }: Props) => {
  const [loading, setLoading] = useState(false)

  const form = useForm<{
    date: string
    duplicate: boolean
    is_test: boolean
    dateRange: DateRange
  }>({
    initialValues: {
      date: CV_LIST_INITIAL_PRESET,
      duplicate: false,
      is_test: false,
      dateRange: [null, null],
    },
  })

  const [startDate, endDate] = form.values.dateRange

  // カスタム選択時に from/to が空のまま送るとサーバ側の Date.parse で例外になるため送信を止める
  const disableSubmit = form.values.date === 'custom' && (!startDate || !endDate)

  return (
    <Box bg="#00000008" p={16} mt={40} bdrs={8}>
      <form
        method="get"
        onSubmit={form.onSubmit(async ({ date, dateRange, ...rest }) => {
          setLoading(true)

          try {
            await onSubmit({ ...rest, ...resolveDateParams(date, dateRange) })
          } finally {
            setLoading(false)
          }
        })}>
        <DatePresetFilter
          value={form.values.date}
          dateRange={form.values.dateRange}
          onChangeValue={(v) => form.setFieldValue('date', v)}
          onChangeDateRange={(r) => form.setFieldValue('dateRange', r)}
        />

        <Group gap={24} mt={16}>
          <Text fz={13} fw={600} c="#000000CC" style={{ width: '100px', textAlign: 'start' }}>CV表示</Text>
          <Group gap={40}>
            <Checkbox
              label="重複CVを除く"
              {...form.getInputProps('duplicate', { type: 'checkbox' })}
            />
            <Checkbox
              label="テストCVを表示"
              {...form.getInputProps('is_test', { type: 'checkbox' })}
            />
          </Group>
        </Group>
        <Group justify="end" mt={16}>
          <Button
            variant="filled"
            radius="xl"
            type="submit"
            fz={13}
            fw={600}
            w={120}
            disabled={loading || disableSubmit}
          >
            {loading ? '処理中' : '表示'}
          </Button>
        </Group>
      </form>
    </Box>
  )
}
